import React from 'react';
import { withRouter } from 'react-router';
import ImageSlider from './ImageSlider';
import RadioBoxMaker from './subcomponents/RadioBoxMaker';
import SizeSelection from './SizeSelection';
import '../statics/stylesheet.css';
import styles from '../statics/styles';

const sizes = ['13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '24', '26', '28'];
let sizeArray = [];

const updateSizeArray = newArray => {
  sizeArray = newArray;
};

class Sizes extends React.Component {

  constructor(props) {
    if (JSON.parse(localStorage.getItem('feedForFilter'))) {
      localStorage.removeItem('feedForFilter');
    }
    super(props);
    this.state = {
      loading: false,
      soratsizing: false,
      soratsizing222: false,
      customsizing: '',
      custominfo: '',
      newoffsetmin: '-999',
      newoffsetmax: '999',
      staggeredOrNot: 'Non-Staggered',
      jeep_wr_old: false,
      jeep_wr_new: false,
      jeep_step2: false,
      jeep_step3: false,
      staggeredSearch: false
    };
  }

  componentWillMount() {
    const { category, search_by, options } = this.props.params;
    sizeArray = [];
    window.sessionStorage.removeItem('Staggered');
    if (search_by === 'Brand') {
      this.getProductsByBrand(category, options);
    } else if (search_by === 'Vehicle') {
      this.getProductByVehicle(category, options, search_by);
    } else if (search_by === 'Size') {
      if (category === 'Wheels') {
        this.getWheelsBySize(options);
      }
      if ( category === 'Tires') {
        this.getTiresBySize(options);
      }
    }
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  getProductsByBrand(category, brand) {
    let url = '';
    if (category === 'Tires') {
      url = 'https://www.soratwheels.ca/apii/tires.php/search/tires/manufacturer/name/' + brand;
    } else if (category === 'Wheels' || category === 'Winter Packages') {
      url = 'https://www.soratwheels.ca/apii/wheels.php/search/wheels/manufacturer/name/' + brand;
    }

    this.setState({ loading: true });

    fetch(url)
      .then(response => {
        return response.json();
      }).then(json => {
        this.setState({ loading: false, products: json });
      });

    return true;
  }

  getProductByVehicle(category, options, search_by) {

    this.setState({ loading: true });
    const isWheelsAndVehicle = category === 'Wheels' && search_by === 'Vehicle';
    const vehicle = options.split('!');
    const modifiedModel = vehicle[2].split('/').join('|');

    if (vehicle[1] === 'TOYOTA' && vehicle[0] > 2007 && vehicle[0] < 2019 && modifiedModel.indexOf('TUNDRA') > -1) {
      this.setState({ soratsizing222: true });
    }
    if (vehicle[1] === 'TOYOTA' && vehicle[0] > 2004 && vehicle[0] < 2023 && modifiedModel.indexOf('TACOMA') > -1) {
      this.setState({ soratsizing222: true });
    }
    if (vehicle[1] === 'RAM TRUCK' && vehicle[0] > 2008 && vehicle[0] < 2019 && modifiedModel.indexOf('1500') > -1 && modifiedModel.indexOf('PRO MASTER 1500') < 0 ) {
      this.setState({ soratsizing222: true });
    }
    if (vehicle[1] === 'FORD' && vehicle[0] > 2007 && ( modifiedModel.indexOf('F-250') > -1 || modifiedModel.indexOf('F-350') > -1) && modifiedModel.indexOf('DUALLY') < -1) {
      this.setState({ soratsizing222: true });
    }
    if (vehicle[1] === 'RAM TRUCK' && vehicle[0] > 2007 && ( modifiedModel.indexOf('2500') > -1 || modifiedModel.indexOf('3500') > -1) && modifiedModel.indexOf('DUALLY') < -1 ) {
      this.setState({ soratsizing222: true });
    }
    if (vehicle[1] === 'AUDI' && (modifiedModel.indexOf('A5') > -1 || modifiedModel.indexOf('S5') > -1) ) {
      this.setState({ soratsizing222: true });
    }
    if (vehicle[1] === 'AUDI' && modifiedModel.indexOf('Q5') > -1 ) {
      this.setState({ soratsizing222: true });
    }
    if (vehicle[1] === 'AUDI' && vehicle[0] > 2015 && modifiedModel.indexOf('Q7') > -1 ) {
      this.setState({ soratsizing222: true });
    }
    if (vehicle[1] === 'AUDI' && vehicle[0] > 2008 && (modifiedModel.indexOf('A4') > -1 || modifiedModel.indexOf('S4') > -1) ) {
      this.setState({ soratsizing222: true });
    }
    if (vehicle[1] === 'AUDI' && vehicle[0] > 2014 && (modifiedModel.indexOf('A3') > -1 || modifiedModel.indexOf('S3') > -1) ) {
      this.setState({ soratsizing222: true });
    }
    if (vehicle[1] === 'TESLA' && modifiedModel.indexOf('MODEL 3') > -1 ) {
      this.setState({ staggeredSearch: true });
    }

    if (isWheelsAndVehicle || category === 'Tires' || category === 'Winter Packages') {
      fetch('https://www.soratwheels.ca/apii/tires.php/search/tires/vehicle/year/' + vehicle[0] + '/make/' + vehicle[1] + '/model/' + modifiedModel)
        .then(response => {
          return response.json();
        }).then(json => {
          localStorage.setItem('Offset_range', Object.values(json.Offset_range));
          localStorage.setItem('Lugnut_Type', Object.values(json.Lugnut_Type));
          localStorage.setItem('Lugnut_Size', Object.values(json.Lugnut_Size));
          localStorage.setItem('Center_bore', Object.values(json.Center_bore));
          localStorage.setItem('bolt_pattern', Object.values(json.bolt_pattern));

          if (Object.keys(json.staggered).length > 0) {
            this.setState({ loading: false, tire_oems: json, staggeredSearch: true });
          } else if (category === 'Winter Packages') {
            this.setState({ loading: false, tire_oems: this.filterTireOEMS(json) });
          } else {
            this.setState({ loading: false, tire_oems: json });
          }
        });

    } else if (category === 'Wheels') {
      fetch('https://www.soratwheels.ca/apii/wheels.php/search/wheels/vehicle/year/' + vehicle[0] + '/make/' + vehicle[1] + '/model/' + modifiedModel )
        .then(response => {
          return response.json();
        }).then(json => {
          this.setState({ loading: false, products: json });
        });
    }
  }

  filterTireOEMS = (tireOptions) => {
    const tires = {
      staggered: tireOptions.staggered,
      standard: {}
    };

    Object.keys(tireOptions.standard).map(
      (tire) => {
        if (tire.includes('OE') || tire.includes('PLUS')) {tires.standard[tire] = tireOptions.standard[tire];}
      }
    );
    return tires;
  }

  getTiresBySize(size) {
    const sizesTires = size.split('-');

    this.setState({ loading: true });

    const url = 'https://www.soratwheels.ca/apii/tires.php/search/tires/size/wheel-profile/' + sizesTires[1] + '/wheel-size/' + sizesTires[2] + '/tread-width/' + sizesTires[0];
    const urlStaggered = 'https://www.soratwheels.ca/apii/tires.php/search/tires/staggered/tread-width-back/' + sizesTires[3] + '/wheel-profile-back/' + sizesTires[4] + '/wheel-size-back/' + sizesTires[5] +
      '/tread-width-front/' + sizesTires[0] + '/wheel-profile-front/' + sizesTires[1] + '/wheel-size-front/' + sizesTires[2];

    if (sizesTires.length > 3) {

      fetch(urlStaggered)
        .then(response => {
          return response.json();
        }).then(json => {
          this.setState({ loading: false, products: json });
        });

    } else {
      fetch(url)
        .then(response => {
          return response.json();
        }).then(json => {
          this.setState({ loading: false, products: json });
        });
    }
  }

  getWheelsBySize(size) {
    const sizesTires = size.split('-');
    this.setState({ loading: true });

    const url = 'https://www.soratwheels.ca/apii/wheels.php/search/wheels/size/offset/' + sizesTires[2] + '/bolt-pattern/' + sizesTires[1] + '/width/' + sizesTires[3] + '/size/' + sizesTires[0];
    const urlStaggered ='https://www.soratwheels.ca/apii/wheels.php/search/wheels/sizestaggered/width-front/' + sizesTires[3] + '/width-back/' + sizesTires[4] +
         '/size/' + sizesTires[0] + '/bolt-pattern/' + sizesTires[1] + '/offset/' + sizesTires[2];

    if (sizesTires.length > 4) {

      fetch(urlStaggered)
        .then(response => {
          return response.json();
        }).then(json => {
          this.setState({ loading: false, products: json });
        });

    } else {
      fetch(url)
        .then(response => {
          return response.json();
        }).then(json => {
          this.setState({ loading: false, products: json });
        });
    }
  }

  getGroupAttribute() {
    const { category, search_by } = this.props.params;

    if (search_by === 'Brand') {
      if (category === 'Wheels') {
        return 'model';
      } else if (category === 'Tires') {
        return 'performance_category';
      }
      return 'model';
    }

    if (category === 'Wheels' || category === 'Winter Packages') {
      return 'wheel_manufacturer';
    } else if (category === 'Tires') {
      return 'tire_manufacturer';
    }
    return 'accessories_manufacturer';
  }

  hasCompatibleTires = (tireOEMS) => {
    const tireIds = Object.keys(tireOEMS);

    function checkOE(tireId) {
      return tireId.includes('OE') || tireId.includes('PLUS');
    }

    function checkSizes(tireId) {
      return tireId.includes(window.sessionStorage.getItem('wheelSize'));
    }

    if (window.sessionStorage.getItem('wheelSize') === null) {
      return tireIds.filter(checkOE).length > 0;
    }
    return tireIds.filter(checkSizes).length > 0;
  }

  onClickWheelSizeSelected = (router) => {
    const { category, search_by, options } = this.props.params;
    const staggeredOrNot = this.state.staggeredOrNot;

    if (staggeredOrNot === 'Staggered') {
      window.sessionStorage.setItem('Staggered', true);
    }

    window.localStorage.setItem('wheels_status', staggeredOrNot);
    window.localStorage.setItem('vsize_search', sizeArray.toString().replace(/,/g, '-'));
    router.push('/' + category.replace(/ /g, '%20') + '/' + search_by + '/' + (options.split(' ').join('%20')).split('/').join('%2F') + '/' + sizeArray.toString().replace(/,/g, '-') + '/');
  }
 
  renderWheelSizeSelection(sizeArray) {

    return (
      <div className="content-divLength">
        <div id="sizesContainer_sizeArray" className="size-selectingWheelSize custom_container">
          <div style={{ textAlign: 'center' }}>
          <h2 className="content-titleFont" style={{ marginBottom: 10 }}>Wheel Size</h2>
            {this.state.staggeredOrNot ? <h3 style={{ color: 'white' }}>{ this.state.staggeredOrNot }</h3> : '' }

            <RadioBoxMaker
            sizeArray={sizeArray}
            submitButton={{ name: 'Go!', classname: 'custom_btn' }}
            onCheckBoxSelect={updateSizeArray}
            divStyle={styles.flexCenterDropDown}
            btnStyle={styles.shoppingMethodButton}
            whenClicked={() => this.onClickWheelSizeSelected(this.context.router)}
          />
          </div>
        </div>
      </div>
    );
  }

  renderWheelSizeSelectiontest(sizeArray) {

    return (
      <div className="content-divLength">
        <div id="sizesContainer_sizeArray" className="size-selectingWheelSize custom_container">

          <div style={{ textAlign: 'center' }}>
          <h2 className="content-titleFont" style={{ marginBottom: 10 }}>Wheel Size</h2>

            <RadioBoxMaker
              sizeArray={sizeArray}
              submitButton={{ name: 'Go!', classname: 'custom_btn' }}
              onCheckBoxSelect={updateSizeArray}
              divStyle={styles.flexCenterDropDown}
              btnStyle={styles.shoppingMethodButton}
              whenClicked={() => this.onClickWheelSizeSelected(this.context.router)}
          />
          </div>
        </div>
      </div>
    );
  }

  renderWinterPackageSelection(sizeArray) {
    return (
        <div className="content-divLength">
          <div id="sizesContainer_sizeArray" className="size-selectingWheelSize custom_container">
            {sizeArray.length === 0 ?
                <h2 className="content-titleFont">No Result</h2> :
                <div style={{ textAlign: 'center' }}>
                  <h2 className="content-titleFont">Wheel Size</h2>
                  {this.state.staggeredOrNot ? <p>{this.state.staggeredOrNot}</p> : ''}

                  <RadioBoxMaker
                      sizeArray={sizeArray}
                      submitButton={{ name: 'Go!', classname: 'custom_btn' }}
                      onCheckBoxSelect={updateSizeArray}
                      divStyle={styles.flexCenterDropDown}
                      btnStyle={styles.shoppingMethodButton}
                      whenClicked={() => this.onClickWheelSizeSelected(this.context.router)}
                  />

                </div>}
          </div>
        </div>
    );
  }

  renderCompatibleTireOptions = (printedItems, staggeredBool) => {
    const { tire_oems } = this.state;
    const { category, search_by, options } = this.props.params;
    const { router } = this.context;
    const tire_oems_standardOrStaggered = staggeredBool === 'true' ? tire_oems.standard : tire_oems.staggered;
    const st = (window.sessionStorage.getItem('staggered') || 'true' ) === 'true';

    if (st) {
      return (
        <div className="size-oemContainer_mainhead" style={{ textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
          {Object.keys(tire_oems_standardOrStaggered).filter((key) => {
      
            if (staggeredBool === 'false') {
              return tire_oems.staggered[key].Front && tire_oems.staggered[key].Rear;
            }
            return true;
          }).map((key) => {
            const url = staggeredBool === 'true' ?
              '/' + category.replace(/ /g, '%20') + '/' + search_by + '/' + (options.split(' ').join('%20')).split('/').join('%2F') + '/' + tire_oems.standard[key].replace('/', '-') :
              '/' + category.replace(/ /g, '%20') + '/' + search_by + '/' + (options.split(' ').join('%20')).split('/').join('%2F') + '/' + tire_oems.staggered[key].Front.replace('/', '-') + '-' + tire_oems.staggered[key].Rear.replace('/', '-');
            const tireSize = staggeredBool === 'true' ? tire_oems.standard[key] : tire_oems.staggered[key].Front + '-' + tire_oems.staggered[key].Rear;
            const tireS = staggeredBool === 'true' ? tire_oems.standard[key].split('-')[1] : tire_oems.staggered[key].Front.split('-')[1];
            return window.sessionStorage.getItem('wheelSize') === null && key.includes('OE') || key.includes(window.sessionStorage.getItem('wheelSize')) ?
              <button key={key} className="size-oemContainer__btn tire_size_label"
                      onClick={(event) => router.push(url)}>
                {staggeredBool === 'true' && <span><span className="size-oemContainer__btn_size">{tireS}"</span><span className="size-oemContainer__btn_value">{tireSize} <small>Front and Rear</small></span><span className="size-oemContainer__btn_carot">></span></span>}
                {staggeredBool === 'false' && 
                  <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <span className="size-oemContainer__btn_size">{tireS}"</span>
                    <span style={{ display: 'flex', gap: '10px' }}>
                      <span className="size-oemContainer__btn_value" style={{width: '40%'}}>{tire_oems.staggered[key].Front} <small>Front</small></span>
                      <span className="size-oemContainer__btn_value" style={{width: '40%'}}>{tire_oems.staggered[key].Rear} <small>Rear</small></span>
                    </span>
                    <span className="size-oemContainer__btn_carot">></span>
                  </span>
                }
              </button> :
              <div/>;
          })
          }
        </div>
      );
    }
    return (
          <div className="size-oemContainer_mainhead" style={{ textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
            {Object.keys(tire_oems_standardOrStaggered).map((key) => {
              const url = staggeredBool === 'true' ?
                  '/' + category.replace(/ /g, '%20') + '/' + search_by + '/' + (options.split(' ').join('%20')).split('/').join('%2F') + '/' + tire_oems.standard[key].replace('/', '-') :
                  '/' + category.replace(/ /g, '%20') + '/' + search_by + '/' + (options.split(' ').join('%20')).split('/').join('%2F') + '/' + tire_oems.staggered[key].Front.replace('/', '-');
              const tireSize = staggeredBool === 'true' ? tire_oems.standard[key] : tire_oems.staggered[key].Front;
              if (printedItems.indexOf(tireSize) >= 0) {
                return '';
              }
              printedItems.push(tireSize);

              const tireS = staggeredBool === 'true' ? tire_oems.standard[key].split('-')[1] : tire_oems.staggered[key].Front.split('-')[1];
              return window.sessionStorage.getItem('wheelSize') === null && (key.includes('OE') || key.includes('PLUS')) || key.includes(window.sessionStorage.getItem('wheelSize')) ?
                  <button key={key} className="size-oemContainer__btn tire_size_label"
                          onClick={(event) => router.push(url)}>
                    <span><span className="size-oemContainer__btn_size">{tireS}"</span><span className="size-oemContainer__btn_value">{tireSize} <small>Front and Rear</small></span><span className="size-oemContainer__btn_carot">></span></span>
                  </button> :
                  <div/>;
            })
            }
          </div>
    );
  }

  renderTireSizeSelection = () => {
    const { tire_oems } = this.state;
    const printedItems = [];
    const showTitle = this.hasCompatibleTires(tire_oems.standard) || this.hasCompatibleTires(tire_oems.staggered);
    if (window.localStorage.getItem('category') === 'Wheels' && window.sessionStorage.getItem('staggered') === 'true') {
      return (

      <div id="sizesContainer_oemsStandard" className="sizeContent-divLength" style={{ flexDirection: 'column' }}>
        <div className="size-oemContainerStandard custom_container">
          {showTitle &&
          <div className="size-oemContainer_mainhead" style={{ textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
          <h1 className="size-oemContainer__heading">Suggested Sizes:</h1>
          </div>}
          {this.hasCompatibleTires(tire_oems.staggered) && this.renderCompatibleTireOptions(printedItems, 'false')}

          <SizeSelection params={this.props} inSizes/>
        </div>
      </div>
      );
    }
    return (

            <div id="sizesContainer_oemsStandard" className="sizeContent-divLength" style={{ flexDirection: 'column' }}>
              <div className="size-oemContainerStandard custom_container">
                {showTitle &&
                <div className="size-oemContainer_mainhead" style={{ textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
                <h1 className="size-oemContainer__heading">Suggested Sizes:</h1>
                </div>}
                {this.hasCompatibleTires(tire_oems.standard) && this.renderCompatibleTireOptions(printedItems, 'true')}
                {this.hasCompatibleTires(tire_oems.staggered) && this.renderCompatibleTireOptions(printedItems, 'false')}

                <SizeSelection params={this.props} inSizes/>
              </div>
            </div>
    );
  }
  pushWinterTireUrl = () => {
    const { category, search_by, options } = this.props.params;
    const { tire_oems } = this.state;
    const { router } = this.context;
    let compatibleTire;

    if (tire_oems) {
      compatibleTire = Object.keys(tire_oems.standard).filter(
        (key) => {
          return key.includes(window.sessionStorage.getItem('wheelSize'));
        });
      if (compatibleTire.length === 1) {router.push('/' + category.replace(/ /g, '%20') + '/' + search_by + '/' + (options.split(' ').join('%20')).split('/').join('%2F') + '/' + tire_oems.standard[compatibleTire[0]].replace('/', '-'));}
    }
  }

  render() {
    const { category, search_by, options } = this.props.params;
    const { loading, products, tire_oems } = this.state;
    const { router } = this.context;

    let customWheelClass;
    category === 'Wheels' ? customWheelClass = '' : customWheelClass = 'search_by_tire_brand';

    if (window.sessionStorage.getItem('winterPackageSelected') === 'true' && !products) {
      this.pushWinterTireUrl();
    }

    if (loading) {
      return (
        <div id="sizesContainer_loading" className="content-divLength">
          {navigator.userAgent.toLowerCase().indexOf('chrome') > -1 || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ?
            <img src={window.host + '/statics/img/loading.svg'}/> :
            <img src={window.host + '/statics/img/loading.gif'}/>}
        </div>
      );
    } else if (products) {
      return (
        <div id="sizesContainer_products" className={customWheelClass}>

          <ImageSlider productData={products} groupAttr={this.getGroupAttribute()}
                       searchBy={search_by} params={this.props.params}/>
        </div>
      );
    } else if (tire_oems) {

      if (tire_oems.standard.length === 0 && tire_oems.staggered.length === 0 ||
        this.state.staggeredOrNot === 'Staggered' && tire_oems.staggered.length === 0 ||
        this.state.staggeredOrNot === 'Non-Staggered' && tire_oems.standard.length === 0) {
        return (
          <div id="sizesContainer_oemsStandard" className="content-divLength">
            <div className="size-noResultDiv">
              <div style={{ textAlign: 'center' }}>
                <h2>No Results</h2>
              </div>
            </div>
          </div>
        );
      }

      if ((category === 'Wheels' || category === 'Winter Packages' ) && search_by === 'Vehicle') {

        if (this.state.soratsizing222) {

          if (window.localStorage.getItem('offset2')) {
            window.localStorage.removeItem('offset2');
          }

          localStorage.setItem('width2', this.state.custominfo);
          localStorage.setItem('offset2', this.state.newoffsetmin);
          localStorage.setItem('offset3', this.state.newoffsetmax);
          localStorage.setItem('customsizing', this.state.customsizing);

          let sizeArray = [];
          const vehiclesize = window.localStorage.getItem('carMake');
          const vehiclesize2 = window.localStorage.getItem('carModel');
          const vehiclesize3 = window.localStorage.getItem('carYear');

          if (vehiclesize === 'TOYOTA' && vehiclesize2.indexOf('TUNDRA') > -1) {
            sizeArray = ['18', '20', '22', '24', '26'];
            return this.renderWheelSizeSelectiontest(sizeArray);

          } else if (vehiclesize === 'RAM TRUCK' && vehiclesize3 > 2008 && vehiclesize3 < 2019 && vehiclesize2.indexOf('1500') > -1 && vehiclesize2.indexOf('PRO MASTER 1500') < 0) {
            sizeArray = [ '17', '18', '20', '22', '24', '26'];
            return this.renderWheelSizeSelectiontest(sizeArray);

          } else if (vehiclesize === 'FORD' && vehiclesize2.indexOf('F-150') > -1) {
            sizeArray = [ '17', '18', '20', '22', '24', '26'];
            return this.renderWheelSizeSelectiontest(sizeArray);

          } else if (vehiclesize === 'FORD' && ( vehiclesize2.indexOf('F-250') > -1 || vehiclesize2.indexOf('F-350') > -1 ) ) {
            sizeArray = [ '17', '18', '20', '22'];
            return this.renderWheelSizeSelectiontest(sizeArray);

          } else if (vehiclesize === 'TOYOTA' && vehiclesize2.indexOf('TACOMA') > -1 ) {
            sizeArray = [ '17', '18'];
            return this.renderWheelSizeSelectiontest(sizeArray);

          } else if (vehiclesize === 'AUDI' && (vehiclesize2.indexOf('A5') > -1 || vehiclesize2.indexOf('S5') > -1) ) {
            sizeArray = [ '18', '19', '20', '21'];
            localStorage.setItem('width2', '> 8.1 and wheel_width < 11');
            localStorage.setItem('offset2', '24');
            localStorage.setItem('offset3', '36');
            localStorage.setItem( 'customsizing', 'Audi');
            return this.renderWheelSizeSelectiontest(sizeArray);

          } else if (vehiclesize === 'AUDI' && vehiclesize2.indexOf('Q5') > -1 ) {
            if (vehiclesize2.indexOf('SQ5') > -1) {
              sizeArray = [ '19', '20', '21', '22'];
            } else {
              sizeArray = [ '18', '19', '20', '21', '22'];
            }
            localStorage.setItem('width2', '> 8.4 and wheel_width < 10.1');
            localStorage.setItem('offset2', '24');
            localStorage.setItem('offset3', '36');
            localStorage.setItem( 'customsizing', 'Audi');
            return this.renderWheelSizeSelectiontest(sizeArray);

          } else if (vehiclesize === 'AUDI' && vehiclesize2.indexOf('Q7') > -1 ) {
            if (vehiclesize3 === '2016' || vehiclesize3 === '2017' ) {
              sizeArray = [ '18', '19', '20', '21', '22'];
              localStorage.setItem('width2', '> 8.4 and wheel_width < 10.6');
              localStorage.setItem('offset2', '34');
              localStorage.setItem('offset3', '51');
              localStorage.setItem( 'customsizing', 'Audi');
            } else {
              sizeArray = ['19', '20', '21', '22'];
              localStorage.setItem('width2', '> 8.9 and wheel_width < 10.6');
              localStorage.setItem('offset2', '19');
              localStorage.setItem('offset3', '36');
              localStorage.setItem( 'customsizing', 'Audi');
            }
            return this.renderWheelSizeSelectiontest(sizeArray);

          } else if (vehiclesize === 'AUDI' && (vehiclesize2.indexOf('A4') > -1 || vehiclesize2.indexOf('S4') > -1) ) {
            sizeArray = [ '18', '19', '20'];
            localStorage.setItem('width2', '> 8.1 and wheel_width < 9.1');
            localStorage.setItem('offset2', '29');
            localStorage.setItem('offset3', '46');
            localStorage.setItem( 'customsizing', 'Audi');
            return this.renderWheelSizeSelectiontest(sizeArray);

          } else if (vehiclesize === 'AUDI' && (vehiclesize2.indexOf('A3') > -1 || vehiclesize2.indexOf('S3') > -1) ) {
            sizeArray = [ '17', '18', '19'];
            localStorage.setItem('width2', '< 8.6');
            localStorage.setItem('offset2', '-999');
            localStorage.setItem('offset3', '999');
            localStorage.setItem( 'customsizing', 'Audi');
            return this.renderWheelSizeSelectiontest(sizeArray);
          }

          let smallestSize;
          let biggestSize;
          smallestSize = Object.keys(tire_oems.standard)[0].split('-')[1];
          biggestSize = Object.keys(tire_oems.standard)[Object.keys(tire_oems.standard).length - 1].split('-')[1];

          if (biggestSize === '25') {
            biggestSize = '26';
          }

          const smallestIndx = sizes.indexOf(smallestSize);
          const biggestIndx = sizes.indexOf(biggestSize) + 1;

          sizeArray = sizes.slice(smallestIndx, biggestIndx);

          const index = sizeArray.indexOf('19');
          if (index > -1) {
            sizeArray.splice(index, 1);
          }
          const index1 = sizeArray.indexOf('21');
          if (index1 > -1) {
            sizeArray.splice(index1, 1);
          }

          return this.renderWheelSizeSelectiontest(sizeArray);
        }

        if (this.state.staggeredSearch) {
          sizeArray = [];
          return (
            <div className="content-divLength">
              <div id="sizesContainer_WheelsVehicle" className="size-selectingStaggeredOrNot custom_container">
                <h2 className="content-titleFont">Staggered or Non Staggered:</h2>
                
                {/* Image to explain staggered concept */}
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  marginBottom: '20px' 
                }}>
                  <img 
                    src="https://soratwheels.ca/media/staggered.png" 
                    alt="Staggered vs Non-Staggered Wheels"
                    style={{
                      maxWidth: '400px',
                      width: '100%',
                      height: 'auto',
                      borderRadius: '8px',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
                    }}
                  />
                </div>

                <h3 className="staggered__message">Your vehicle has the option for staggered wheels, would you like to
                  search for staggered or non-staggered wheels?</h3>
                
                <div className='button-container' style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '20px',
                  paddingTop: 5,
                  paddingBottom: '15px',
                  width: '100%',
                  flexWrap: 'wrap'
                }}>
                   <button 
                    onClick={(searchBy) => this.setState({
                      staggeredSearch: false,
                      staggeredOrNot: 'Non-Staggered'
                    })}
                    style={{
                      background: 'linear-gradient(135deg, #C50000 0%, #a00000 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '3px',
                      padding: '16px 32px',
                      fontSize: '16px',
                      fontWeight: '600',
                      textTransform: 'uppercase',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 4px 12px rgba(197, 0, 0, 0.3)',
                      minWidth: '235px',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 6px 16px rgba(197, 0, 0, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 4px 12px rgba(197, 0, 0, 0.3)';
                    }}
                  >
                    ✓ Non-Staggered
                  </button>

                  <button 
                    onClick={(searchBy) => this.setState({
                      staggeredSearch: false,
                      staggeredOrNot: 'Staggered'
                    })}
                    style={{
                      background: 'linear-gradient(135deg, #C50000 0%, #a00000 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '3px',
                      padding: '16px 32px',
                      fontSize: '16px',
                      fontWeight: '600',
                      textTransform: 'uppercase',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 4px 12px rgba(197, 0, 0, 0.3)',
                      minWidth: '235px',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 6px 16px rgba(197, 0, 0, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 4px 12px rgba(197, 0, 0, 0.3)';
                    }}
                  >
                    ⚙ Staggered
                  </button>

                </div>
              </div>
            </div>
          );
        }

        if (category === 'Winter Packages') {
          sizeArray = [];
          let smallestSize;
          let biggestSize;

          if (this.state.staggeredOrNot === 'Staggered') {
            smallestSize = Object.keys(tire_oems.staggered)[0].split('-')[1];
            biggestSize = Object.keys(tire_oems.staggered)[Object.keys(tire_oems.staggered).length - 1].split('-')[1];

          } else {
            smallestSize = Object.keys(tire_oems.standard)[0].split('-')[1];
            biggestSize = Object.keys(tire_oems.standard)[Object.keys(tire_oems.standard).length - 1].split('-')[1];
          }
          const smallestIndx = sizes.indexOf(smallestSize) - 1;
          const biggestIndx = sizes.indexOf(biggestSize) + 1;
          sizeArray = sizes.slice(smallestIndx, biggestIndx);

          return this.renderWinterPackageSelection(sizeArray);
        }

        let smallestSize;
        let biggestSize;

        if (this.state.staggeredOrNot === 'Staggered') {
          window.localStorage.setItem('wheels_status', 'Staggered');
          smallestSize = Object.keys(tire_oems.staggered)[0].split('-')[1];
          biggestSize = Object.keys(tire_oems.staggered)[Object.keys(tire_oems.staggered).length - 1].split('-')[1];
        } else {
          window.localStorage.setItem('wheels_status', 'Non-Staggered');
          smallestSize = Object.keys(tire_oems.standard)[0].split('-')[1];
          biggestSize = Object.keys(tire_oems.standard)[Object.keys(tire_oems.standard).length - 1].split('-')[1];

          if (biggestSize === '25') {
            biggestSize = '26';
          }
        }

        const smallestIndx = sizes.indexOf(smallestSize) - 0;
        const biggestIndx = sizes.indexOf(biggestSize) + 1;
        sizeArray = sizes.slice(smallestIndx, biggestIndx);

        const vehiclesize = window.localStorage.getItem('carMake');
        const vehiclesize2 = window.localStorage.getItem('carModel');
        const vehiclesize3 = window.localStorage.getItem('carYear');

        if (vehiclesize === 'TESLA' && vehiclesize2.indexOf('MODEL 3') > -1 ) {
          localStorage.setItem('width2', '> 7.9 and wheel_width < 9.1');
          localStorage.setItem('offset2', '29');
          localStorage.setItem('offset3', '41');
          localStorage.setItem( 'customsizing', 'TESLA3');
          localStorage.setItem( 'search_by', 'TESLA3');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }

        if (vehiclesize === 'TESLA' && vehiclesize2.indexOf('MODEL S') > -1 ) {
          sizeArray = [ '19', '20', '21', '22'];
          localStorage.setItem('width2', '> 8.4 and wheel_width < 9.1');
          localStorage.setItem('offset2', '19');
          localStorage.setItem('offset3', '36');
          localStorage.setItem( 'customsizing', 'TESLA S');
          localStorage.setItem( 'search_by', 'TESLA S');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }

        if (vehiclesize === 'TESLA' && vehiclesize2.indexOf('MODEL X') > -1 ) {
          sizeArray = [ '20', '21', '22'];
          localStorage.setItem('width2', '> 8.4 and wheel_width < 8.6');
          localStorage.setItem('offset2', '19');
          localStorage.setItem('offset3', '39');
          localStorage.setItem( 'customsizing', 'TESLA X');
          localStorage.setItem( 'search_by', 'TESLA X');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }

        if (vehiclesize === 'TESLA' && vehiclesize2.indexOf('MODEL Y') > -1 && this.state.staggeredOrNot === 'Non-Staggered') {
          sizeArray = [ '18', '19', '20', '21', '22'];
          localStorage.setItem('width2', '> 8.4 and wheel_width < 9.6');
          localStorage.setItem('offset2', '24');
          localStorage.setItem('offset3', '46');
          localStorage.setItem( 'customsizing', 'TESLA Y');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }

        if (vehiclesize === 'TESLA' && vehiclesize2.indexOf('MODEL Y') > -1 && this.state.staggeredOrNot === 'Staggered') {
          sizeArray = ['20', '21', '22'];
          localStorage.setItem( 'search_by', 'TESLA Y');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }

        if (vehiclesize === 'JEEP' && vehiclesize2.indexOf('WRANGLER') > -1 && vehiclesize3 > 2006) {
          sizeArray = ['17', '18', '20', '22', '24', '26'];
          return this.renderWheelSizeSelectiontest(sizeArray);
        }

        if (vehiclesize === 'MERCEDES' && vehiclesize2.indexOf('S CLASS') > -1 && this.state.staggeredOrNot === 'Staggered' && vehiclesize3 > 2006 && vehiclesize3 < 2014) {
          sizeArray = [ '19', '20'];
          localStorage.setItem( 'search_by', 'S CLASS old');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'MERCEDES' && vehiclesize2.indexOf('S CLASS') > -1 && this.state.staggeredOrNot === 'Staggered' && vehiclesize3 > 2013 && vehiclesize3 < 2021) {
          localStorage.setItem( 'search_by', 'S CLASS new');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }

        if (vehiclesize === 'MERCEDES' && vehiclesize2.indexOf('S CLASS') > -1 && this.state.staggeredOrNot === 'Non-Staggered' && vehiclesize3 > 2006 && vehiclesize3 < 2014) {
          sizeArray = [ '18', '19', '20'];
          localStorage.setItem('width2', '> 7.9 and wheel_width < 9.1');
          localStorage.setItem('offset2', '29');
          localStorage.setItem('offset3', '46');
          localStorage.setItem( 'customsizing', 'MERCEDES');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }

        if (vehiclesize === 'MERCEDES' && vehiclesize2.indexOf('C CLASS') > -1 && this.state.staggeredOrNot === 'Non-Staggered' && vehiclesize3 > 2006 && vehiclesize3 < 2014) {
          sizeArray = [ '17', '18', '19'];
          localStorage.setItem('width2', '> 7.4 and wheel_width < 8.6');
          localStorage.setItem('offset2', '34');
          localStorage.setItem('offset3', '46');
          localStorage.setItem( 'customsizing', 'MERCEDES');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'MERCEDES' && vehiclesize2.indexOf('C CLASS') > -1 && this.state.staggeredOrNot === 'Staggered' && vehiclesize3 > 2006 && vehiclesize3 < 2014) {
          sizeArray = [ '18', '19'];
          localStorage.setItem( 'search_by', 'C CLASS old');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'MERCEDES' && vehiclesize2.indexOf('C CLASS') > -1 && this.state.staggeredOrNot === 'Non-Staggered' && vehiclesize3 > 2013 && vehiclesize3 < 2022) {
          sizeArray = [ '18', '19'];
          localStorage.setItem('width2', '> 7.9 and wheel_width < 8.6');
          localStorage.setItem('offset2', '34');
          localStorage.setItem('offset3', '46');
          localStorage.setItem( 'customsizing', 'MERCEDES');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'MERCEDES' && vehiclesize2.indexOf('C43 AMG') > -1 && this.state.staggeredOrNot === 'Non-Staggered' && vehiclesize3 > 2014 && vehiclesize3 < 2024) {
          sizeArray = [ '18', '19' ];
          localStorage.setItem('width2', '> 7.9 and wheel_width < 8.6');
          localStorage.setItem('offset2', '21');
          localStorage.setItem('offset3', '31');
          localStorage.setItem( 'customsizing', 'MERCEDES');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'MERCEDES' && vehiclesize2.indexOf('C43 AMG') > -1 && this.state.staggeredOrNot === 'Staggered') {
          sizeArray = [ '18', '19'];
          localStorage.setItem( 'search_by', 'C43');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'BMW' && vehiclesize2.indexOf('X7') > -1 && this.state.staggeredOrNot === 'Non-Staggered') {
          sizeArray = [ '20', '22', '24'];
          localStorage.setItem('width2', '> 8.9 and wheel_width < 10.1');
          localStorage.setItem('offset2', '16');
          localStorage.setItem('offset3', '41');
          localStorage.setItem( 'customsizing', 'MERCEDES');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'BMW' && vehiclesize2.indexOf('X7') > -1 && this.state.staggeredOrNot === 'Staggered') {
          sizeArray = [ '21', '22', '24'];
          localStorage.setItem( 'search_by', 'BMW X7');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'MERCEDES' && vehiclesize2.indexOf('GL CLASS') > -1 && vehiclesize3 > 2005 && vehiclesize3 < 2013) {
          sizeArray = [ '18', '19', '20', '21', '22'];
          localStorage.setItem('width2', '> 8.9 and wheel_width < 10.6');
          localStorage.setItem('offset2', '29');
          localStorage.setItem('offset3', '46');
          localStorage.setItem( 'customsizing', 'MERCEDES');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'MERCEDES' && vehiclesize2.indexOf('GLS CLASS') > -1 && vehiclesize3 > 2012 && vehiclesize3 < 2020) {
          sizeArray = ['20', '21', '22'];
          localStorage.setItem('width2', '> 8.9 and wheel_width < 10.6');
          localStorage.setItem('offset2', '29');
          localStorage.setItem('offset3', '46');
          localStorage.setItem( 'customsizing', 'MERCEDES');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }

        if (vehiclesize === 'FORD' && vehiclesize2.indexOf('BRONCO') > -1 && vehiclesize2.indexOf('BRONCO SPORT') < 0 ) {
          sizeArray = [ '17', '18', '20', '22', '24'];
          localStorage.setItem('width2', '> 7.9 and wheel_width < 9.1');
          localStorage.setItem('offset2', '0.0');
          localStorage.setItem('offset3', '36');
          localStorage.setItem( 'customsizing', 'FORD');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'MERCEDES' && vehiclesize2.indexOf('C CLASS') > -1 && this.state.staggeredOrNot === 'Staggered' && vehiclesize3 > 2013 && vehiclesize3 < 2022) {
          sizeArray = ['18', '19'];
          localStorage.setItem( 'search_by', 'C CLASS new');
        }

        if (vehiclesize2.indexOf('JETTA') > -1 && vehiclesize3 > 2006 && vehiclesize3 < 2018 ) {
          sizeArray = ['16', '17', '18', '19'];
          localStorage.setItem('width2', '> 7.4 and wheel_width < 8.6');
          localStorage.setItem('offset2', '41');
          localStorage.setItem('offset3', '49');
          localStorage.setItem( 'customsizing', 'JETTA');
          localStorage.setItem( 'search_by', 'JETTA');
        }
        if (vehiclesize2.indexOf('JETTA') > -1 && vehiclesize3 > 2017 ) {
          sizeArray = ['16', '17', '18', '19'];
          localStorage.setItem('width2', '> 6.9 and wheel_width < 8.6');
          localStorage.setItem('offset2', '39');
          localStorage.setItem('offset3', '46');
          localStorage.setItem( 'customsizing', 'JETTA');
          localStorage.setItem( 'search_by', 'JETTA');
        }
        if (vehiclesize === 'BMW' && vehiclesize3 > 2018 && vehiclesize3 < 2023 && this.state.staggeredOrNot === 'Non-Staggered' && ( vehiclesize2.indexOf('X5') > -1 || vehiclesize2.indexOf('X6') > -1) ) {
          sizeArray = [ '20', '21', '22'];
          localStorage.setItem('width2', '> 8.4 and wheel_width < 10.6');
          localStorage.setItem('offset2', '24');
          localStorage.setItem('offset3', '36');
          localStorage.setItem( 'customsizing', 'BMW x5 x6 new');
          localStorage.setItem( 'search_by', 'BMW x5 x6 new');
        }
        if (vehiclesize === 'BMW' && vehiclesize3 > 2018 && vehiclesize3 < 2023 && this.state.staggeredOrNot !== 'Non-Staggered' && ( vehiclesize2.indexOf('X5') > -1 || vehiclesize2.indexOf('X6') > -1) ) {
          sizeArray = [ '20', '21', '22'];
          localStorage.setItem( 'search_by', 'BMW x5 x6 new');
        }
        if (vehiclesize === 'BMW' && vehiclesize3 > 2006 && vehiclesize3 < 2019 && this.state.staggeredOrNot === 'Non-Staggered' && ( vehiclesize2.indexOf('X5') > -1 || vehiclesize2.indexOf('X6') > -1) ) {
          sizeArray = [ '18', '19', '20', '21', '22'];
          localStorage.setItem('width2', '> 8.4 and wheel_width < 10.1');
          localStorage.setItem('offset2', '29');
          localStorage.setItem('offset3', '43');
          localStorage.setItem( 'customsizing', 'BMW x5 x6 old');
          localStorage.setItem( 'search_by', 'BMW x5 x6 old');
        }
        if (vehiclesize === 'BMW' && vehiclesize3 > 2006 && vehiclesize3 < 2019 && this.state.staggeredOrNot !== 'Non-Staggered' && ( vehiclesize2.indexOf('X5') > -1 || vehiclesize2.indexOf('X6') > -1) ) {
          sizeArray = [ '20', '21', '22'];
          localStorage.setItem( 'search_by', 'BMW x5 x6 old');
        }
        if (vehiclesize === 'BMW' && vehiclesize3 > 1997 && vehiclesize3 < 2006 && vehiclesize2.indexOf('3 SERIES') > -1 ) {
          sizeArray = [ '16', '17', '18', '19'];
        }
        if (vehiclesize === 'BMW' && vehiclesize3 > 2005 && vehiclesize3 < 2013 && this.state.staggeredOrNot === 'Non-Staggered' && ( vehiclesize2.indexOf('3 SERIES') > -1 && vehiclesize2.indexOf('335') < 0 ) || vehiclesize2.indexOf('Z4') > -1 ) {
          sizeArray = [ '16', '17', '18', '19'];
          localStorage.setItem('width2', '> 7.4 and wheel_width < 8.6');
          localStorage.setItem('offset2', '29');
          localStorage.setItem('offset3', '41');
          localStorage.setItem( 'customsizing', 'BMW 3 old');
          localStorage.setItem( 'search_by', 'BMW 3 old');
        }
        if (vehiclesize === 'BMW' && vehiclesize3 > 2005 && vehiclesize3 < 2013 && this.state.staggeredOrNot === 'Non-Staggered' && ( vehiclesize2.indexOf('3 SERIES') > -1 && vehiclesize2.indexOf('335') > -1 )) {
          sizeArray = [ '18', '19'];
          localStorage.setItem('width2', '> 7.4 and wheel_width < 8.6');
          localStorage.setItem('offset2', '29');
          localStorage.setItem('offset3', '41');
          localStorage.setItem( 'customsizing', 'BMW 3 old');
          localStorage.setItem( 'search_by', 'BMW 3 old');
        }
        if (vehiclesize === 'BMW' && vehiclesize3 > 2005 && vehiclesize3 < 2013 && this.state.staggeredOrNot !== 'Non-Staggered' && vehiclesize2.indexOf('3 SERIES') > -1 ) {
          sizeArray = ['19'];
          localStorage.setItem( 'search_by', 'BMW 3 old');
        }
        if (vehiclesize === 'BMW' && vehiclesize3 > 2012 && vehiclesize3 < 2019 && this.state.staggeredOrNot === 'Non-Staggered' && ( vehiclesize2.indexOf('3 SERIES') > -1 || vehiclesize2.indexOf('4 SERIES') > -1 ) ) {
          sizeArray = [ '17', '18', '19', '20'];
          localStorage.setItem('width2', '> 7.4 and wheel_width < 9.1');
          localStorage.setItem('offset2', '34');
          localStorage.setItem('offset3', '46');
          localStorage.setItem( 'customsizing', 'BMW 3-4 old');
          localStorage.setItem( 'search_by', 'BMW 3-4 old');
        }
        if (vehiclesize === 'BMW' && vehiclesize3 > 2012 && vehiclesize3 < 2019 && this.state.staggeredOrNot !== 'Non-Staggered' && ( vehiclesize2.indexOf('3 SERIES') > -1 || vehiclesize2.indexOf('4 SERIES') > -1 ) ) {
          sizeArray = ['19', '20'];
          localStorage.setItem( 'search_by', 'BMW 3-4 old');
        }
        if (vehiclesize === 'BMW' && vehiclesize3 > 2017 && vehiclesize3 < 2019 && ( vehiclesize2.indexOf('3 SERIES') > -1 || vehiclesize2.indexOf('4 SERIES') > -1 ) && vehiclesize2.indexOf('335') < 1 &&
        vehiclesize2.indexOf('435') < 1 && vehiclesize2.indexOf('440') < 1 && vehiclesize2.indexOf('340') < 1 ) {
          sizeArray = [ '17', '18', '19', '20'];
        }
        if (vehiclesize === 'TOYOTA' && vehiclesize3 > 2006 && vehiclesize3 < 2022 && vehiclesize2.indexOf('4-RUNNER') > -1 ) {
          sizeArray = [ '17', '18', '20', '22'];
        }
        if (vehiclesize === 'RAM TRUCK' && vehiclesize3 > 2018 && vehiclesize2.indexOf('1500 6 LUG') > -1 ) {
          sizeArray = [ '20', '22', '24', '26', '28'];
        }
        if (vehiclesize === 'TOYOTA' && vehiclesize3 > 1999 && vehiclesize2.indexOf('RAV4') > -1 ) {
          sizeArray = [ '16', '17', '18', '19', '20', '21', '22'];
        }
        if (vehiclesize === 'SUBARU' && vehiclesize2.indexOf('CROSSTREK') > -1 ) {
          sizeArray = [ '15', '16', '17', '18', '19', '20'];
        }
        if (vehiclesize === 'CHEVROLET' && vehiclesize3 > 2018 && vehiclesize2.indexOf('SILVERADO 1500') > -1 ) {
          sizeArray = [ '18', '20', '22', '24', '26'];
        }
        if (vehiclesize === 'CHEVROLET' && vehiclesize3 > 2006 && vehiclesize2.indexOf('TAHOE') > -1 ) {
          sizeArray = [ '17', '18', '20', '22', '24', '26'];
          localStorage.setItem('width2', '> 8.4 and wheel_width < 10.1');
          localStorage.setItem('offset2', '14');
          localStorage.setItem('offset3', '36');
          localStorage.setItem( 'customsizing', 'TAHOE');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'CHEVROLET' && vehiclesize3 > 2006 && vehiclesize2.indexOf('SUBURBAN') > -1 ) {
          sizeArray = [ '17', '18', '20', '22', '24', '26'];
          localStorage.setItem('width2', '> 8.4 and wheel_width < 10.1');
          localStorage.setItem('offset2', '14');
          localStorage.setItem('offset3', '36');
          localStorage.setItem( 'customsizing', 'YUKON');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'GMC' && vehiclesize3 > 2018 && vehiclesize2.indexOf('SIERRA 1500') > -1 ) {
          sizeArray = [ '18', '20', '22', '24', '26'];
        }
        if (vehiclesize === 'GMC' && vehiclesize3 > 2006 && vehiclesize2.indexOf('YUKON') > -1 ) {
          sizeArray = [ '17', '18', '20', '22', '24', '26'];
          localStorage.setItem('width2', '> 8.4 and wheel_width < 10.1');
          localStorage.setItem('offset2', '14');
          localStorage.setItem('offset3', '36');
          localStorage.setItem( 'customsizing', 'YUKON');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'CADILLAC' && vehiclesize3 > 2006 && vehiclesize2.indexOf('ESCALADE') > -1 ) {
          sizeArray = [ '17', '18', '20', '22', '24', '26'];
          localStorage.setItem('width2', '> 8.4 and wheel_width < 10.1');
          localStorage.setItem('offset2', '14');
          localStorage.setItem('offset3', '36');
          localStorage.setItem( 'customsizing', 'ESCALADE');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'VOLKSWAGEN' && vehiclesize2.indexOf('GOLF R') > -1 ) {
          sizeArray = [ '17', '18', '19'];
          localStorage.setItem('width2', '> 7.4 and wheel_width < 8.6');
          localStorage.setItem('offset2', '34');
          localStorage.setItem('offset3', '49');
          localStorage.setItem( 'customsizing', 'GOLF R');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'JEEP' && vehiclesize2.indexOf('GRAND CHEROKEE') > -1 && vehiclesize3 > 2011 ) {
          if (vehiclesize2.indexOf('SRT') > -1) {
            sizeArray = ['20', '22'];
          } else {
            sizeArray = [ '18', '20', '22'];
          }
          localStorage.setItem('width2', '< 11');
          localStorage.setItem('offset2', '34');
          localStorage.setItem('offset3', '999');
          localStorage.setItem( 'customsizing', 'Audi');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'LAND ROVER' && vehiclesize2.indexOf('RANGE ROVER') > -1 && vehiclesize3 > 2013 ) {
          sizeArray = [ '20', '21', '22', '24'];
          localStorage.setItem('width2', '> 10.4');
          localStorage.setItem('offset2', '14');
          localStorage.setItem('offset3', '999');
          localStorage.setItem( 'customsizing', 'Audi');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'HYUNDAI' && vehiclesize2.indexOf('SANTA FE') > -1 && vehiclesize3 > 2011 ) {
          sizeArray = [ '17', '18', '19', '20', '21', '22'];
          localStorage.setItem('width2', '> 7.4 and wheel_width < 9.1');
          localStorage.setItem('offset2', '29');
          localStorage.setItem('offset3', '46');
          localStorage.setItem( 'customsizing', 'Audi');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'HONDA' && vehiclesize2.indexOf('CIVIC') > -1 && vehiclesize3 > 2005 && vehiclesize3 < 2016 ) {
          sizeArray = [ '15', '16', '17', '18', '19'];
          localStorage.setItem('width2', '> 5.9 and wheel_width < 8.6');
          localStorage.setItem('offset2', '34');
          localStorage.setItem('offset3', '46');
          localStorage.setItem( 'customsizing', 'Audi');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'HONDA' && vehiclesize2.indexOf('CIVIC') > -1 && vehiclesize2.indexOf('TYPE R') < 0 && vehiclesize3 > 2015 ) {
          sizeArray = [ '16', '17', '18', '19'];
          localStorage.setItem('width2', '> 6.9 and wheel_width < 8.6');
          localStorage.setItem('offset2', '34');
          localStorage.setItem('offset3', '46');
          localStorage.setItem( 'customsizing', 'Audi');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'HONDA' && vehiclesize2.indexOf('CIVIC') > -1 && vehiclesize2.indexOf('TYPE R') > -1 && vehiclesize3 > 2020 ) {
          sizeArray = [ '18', '19', '20'];
          localStorage.setItem('width2', '> 7.9 and wheel_width < 9.1');
          localStorage.setItem('offset2', '29');
          localStorage.setItem('offset3', '46');
          localStorage.setItem( 'customsizing', 'Audi');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }

        if (vehiclesize === 'PORSCHE' && vehiclesize2.indexOf('CAYENNE') > -1 && vehiclesize3 > 2006 && vehiclesize3 < 2019 && this.state.staggeredOrNot === 'Non-Staggered') {
          sizeArray = [ '18', '19', '20', '21', '22'];
          localStorage.setItem('width2', '> 8.9 and wheel_width < 10.6');
          localStorage.setItem('offset2', '34');
          localStorage.setItem('offset3', '46');
          localStorage.setItem( 'customsizing', 'Audi');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'LEXUS' && vehiclesize2.indexOf('RX 350') > -1 ) {
          sizeArray = [ '18', '19', '20', '21', '22'];
          localStorage.setItem('width2', '> 8.4');
          localStorage.setItem('offset2', '20');
          localStorage.setItem('offset3', '39');
          localStorage.setItem( 'customsizing', 'Audi');
          return this.renderWheelSizeSelectiontest(sizeArray);
        }
        if (vehiclesize === 'FORD' && ( vehiclesize2.indexOf('EDGE') > -1 || vehiclesize2.indexOf('ESCAPE') > -1 ) ) {
          sizeArray = [ '17', '18', '19', '20', '21', '22'];
          return this.renderWheelSizeSelectiontest(sizeArray);
        }

        if (vehiclesize === 'FORD' && vehiclesize2.indexOf('F-150') > -1 && vehiclesize2.indexOf('RAPTOR') < 0 && vehiclesize3 > 2004 && vehiclesize3 < 2024 ) {
          sizeArray = [ '17', '18', '20', '22', '24', '26'];
          this.setState({ soratsizing: true });
        }

        return this.renderWheelSizeSelection(sizeArray);
      }
      return this.renderTireSizeSelection();
    }
    return <div>No Value</div>;
  }
}

Sizes.propTypes = {
  params: React.PropTypes.object.isRequired
};

Sizes.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default withRouter(Sizes);



// WEBPACK FOOTER //
// ./src/components/Sizes.js